import { ActionTypes } from '../constants/index';

export const ecommerceAction = (payload: any) => ({
  type: ActionTypes.ECOMMERCE_LIST_REQUEST,
  payload,
});
